var RE=/-webkit-|-moz-|-ms-/;export default function isPrefixedValue(value){return"string"==typeof value&&RE.test(value)}